<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.0573 10.9041H3.94391V16.2765C3.94391 18.7256 5.92556 20.7112 8.3776 20.7112C10.5995 20.7112 13.3918 20.7112 15.6236 20.7112C18.0657 20.7112 20.0573 18.7256 20.0573 16.2765V10.9041ZM3.94391 9.65301H20.0573V9.03049C20.0573 6.58115 18.0657 4.5957 15.6236 4.5957H14.843V3.91954C14.843 3.57425 14.5628 3.29401 14.2225 3.29401C13.8722 3.29401 13.5919 3.57425 13.5919 3.91954V4.5957H10.3993V3.91954C10.3993 3.57425 10.1191 3.29401 9.76876 3.29401C9.42848 3.29401 9.14824 3.57425 9.14824 3.91954V4.5957H8.3776C5.92556 4.5957 3.94391 6.58115 3.94391 9.03049V9.65301Z"
      fill="#3CA091"
    />
  </svg>
</template>

<script>
export default {
  name: 'CalendarSelected'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
